import React from "react";
interface ProseProps {
  children: React.ReactNode;
  size?: "sm" | "base" | "lg";
}
export const Prose: React.FC<ProseProps> = ({
  children,
  size = "base"
}) => {
  const sizeClasses = {
    sm: "prose-sm",
    base: "prose-base",
    lg: "prose-lg"
  };
  return <div className={`
                prose prose-invert prose-slate max-w-none ${sizeClasses[size]}
                
                prose-headings:font-bold prose-headings:tracking-tight prose-headings:text-slate-100
                prose-headings:scroll-mt-16
                
                prose-h1:text-3xl prose-h1:mt-8 prose-h1:mb-6
                prose-h2:text-2xl prose-h2:mt-7 prose-h2:mb-5
                prose-h3:text-xl prose-h3:mt-6 prose-h3:mb-4
                prose-h4:text-lg prose-h4:mt-5 prose-h4:mb-3
                
                prose-p:text-slate-300 prose-p:leading-7 prose-p:my-5
                
                prose-a:text-sky-400 prose-a:font-medium prose-a:no-underline hover:prose-a:text-sky-300
                
                prose-blockquote:border-l-4 prose-blockquote:border-sky-700 
                prose-blockquote:bg-slate-800/50 prose-blockquote:px-6 
                prose-blockquote:py-4 prose-blockquote:italic prose-blockquote:text-slate-300
                
                prose-ul:pl-8 prose-ol:pl-8 prose-li:my-3 prose-li:text-slate-300
                
                prose-hr:border-slate-700 prose-hr:my-12
                
                prose-pre:bg-slate-900 prose-pre:border prose-pre:border-slate-700 
                prose-pre:overflow-auto prose-pre:rounded-lg prose-pre:shadow-md
                
                prose-code:bg-slate-900 prose-code:border prose-code:border-slate-700 
                prose-code:px-2 prose-code:py-1 prose-code:rounded-md prose-code:text-sm
                prose-code:before:content-none prose-code:after:content-none
                
                prose-img:mx-auto prose-img:rounded-lg prose-img:shadow-md
                
                prose-strong:font-bold prose-strong:text-white prose-em:italic
                
                prose-table:w-full prose-table:border-collapse prose-thead:bg-slate-800
                prose-th:border prose-th:border-slate-700 prose-th:p-3 prose-th:font-semibold
                prose-td:border prose-td:border-slate-700 prose-td:p-3
                
                prose-figure:text-center prose-figcaption:text-sm prose-figcaption:text-slate-400 prose-figcaption:mt-3
                
                [&>*:first-child]:mt-0 [&>*:last-child]:mb-0
            `} data-sentry-component="Prose" data-sentry-source-file="index.tsx">
            {children}
        </div>;
};